import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Bookmark {
  id: number;
  item_type: string;
  item_id: string;
  notes?: string;
  created_at: string;
}

interface BookmarkState {
  items: Bookmark[];
  loading: boolean;
  error: string | null;
}

const initialState: BookmarkState = {
  items: [],
  loading: false,
  error: null,
};

const bookmarkSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    setBookmarks: (state, action: PayloadAction<Bookmark[]>) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    addBookmark: (state, action: PayloadAction<Bookmark>) => {
      state.items.unshift(action.payload);
    },
    removeBookmark: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((b) => b.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setBookmarks, addBookmark, removeBookmark, setLoading, setError } =
  bookmarkSlice.actions;
export default bookmarkSlice.reducer;
